import { render, staticRenderFns } from "./AssistantToggleHeader.vue?vue&type=template&id=0b9c360c&scoped=true"
import script from "./AssistantToggleHeader.vue?vue&type=script&lang=ts"
export * from "./AssistantToggleHeader.vue?vue&type=script&lang=ts"
import style0 from "./AssistantToggleHeader.vue?vue&type=style&index=0&id=0b9c360c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c360c",
  null
  
)

export default component.exports